import type { CrmConnectionRow } from './types';

/**
 * Display names for the CRM sources a connection row can carry.
 *
 * Lifted verbatim (controller ruling, p6 Task 2) from the console's own
 * `apps/console/src/resources/integrations/crmSourceLabel.ts` — which used to
 * hardcode "Salesforce", true while Salesforce was the only source and wrong
 * from p4 onward, when the portal's OAuth broker started minting HubSpot rows
 * that the cross-tenant console list also shows. A HubSpot connection
 * labelled "Salesforce" (and a delete dialog promising leads would stop
 * exporting to Salesforce) is an operator acting on the wrong system.
 *
 * Lives in the shared slice — not the console — because BOTH `ConnectionsTable`
 * and `ConnectionDetail` (portal + console alike) render source-aware copy.
 */
const CRM_SOURCE_LABELS: Record<CrmConnectionRow['crmSource'], string> = {
  salesforce: 'Salesforce',
  hubspot: 'HubSpot',
  zoho: 'Zoho',
};

/**
 * Label for a connection's `crmSource`. Falls back to the raw value rather
 * than a placeholder: a backend that starts returning a source this build
 * does not know about should show that source's name, not "Unknown" — the
 * operator can act on 'pipedrive' and cannot act on '—'.
 */
export function crmSourceLabel(source: string | undefined): string {
  if (!source) return '';
  return CRM_SOURCE_LABELS[source as CrmConnectionRow['crmSource']] ?? source;
}
